export default class DownloadCsvFromArray {
  static downloadableCSV(rows, filename, headers = []) {
    let csv = "";

    if (headers.length > 0) {
      csv += headers.join(",") + "\n";
    }

    rows.forEach(function(row) {
      csv += row.join(",") + "\n";
    });

    const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  }
}
